import { displayDefaultDateTime } from 'app/shared/util/date-utils';
import { displayPercent } from 'app/shared/util/percent';
import * as _ from 'lodash';

export const commonColumns = [
  {
    title: 'Ngày bắt đầu',
    sorter: true,
    key: 'startDate',
    fixed: 'left',
    width: 120,
    dataIndex: 'startDate',
    render: item => displayDefaultDateTime(item),
  },
  {
    title: 'Thời hạn hoàn thành',
    sorter: true,
    key: 'dueDate',
    fixed: 'left',
    width: 120,
    dataIndex: 'dueDate',
    render: item => displayDefaultDateTime(item),
  },
];

export const columnsYear = [
  {
    title: 'KR năm',
    key: 'purpose',
    fixed: 'left',
    width: 200,
    dataIndex: 'purpose',
  },
  {
    title: 'Tỷ trọng năm',
    key: 'contribution',
    width: 100,
    dataIndex: 'contribution',
    render(item) {
      if (item) {
        if (Number.isInteger(displayPercent(item ?? 0))) return `${displayPercent(item ?? 0)}%`;
        return `${displayPercent(item ?? 0).toFixed(2)}%`;
      }
    },
  },
  {
    title: 'Quý I',
    key: 'quarterOnePurpose',
    width: 200,
    dataIndex: 'quarterOnePurpose',
  },
  {
    title: 'Quý II',
    key: 'quarterTwoPurpose',
    width: 200,
    dataIndex: 'quarterTwoPurpose',
  },
  {
    title: 'Quý III',
    key: 'quarterThreePurpose',
    width: 200,
    dataIndex: 'quarterThreePurpose',
  },
  {
    title: 'Quý IV',
    width: 200,
    key: 'quarterFourPurpose',
    dataIndex: 'quarterFourPurpose',
  },
  {
    title: 'Tình trạng KR năm',
    width: 100,
    key: 'status',
    dataIndex: 'status',
  },
];

export const columnsQuarter = [
  {
    title: 'Tình trạng KR quý',
    width: 100,
    key: 'status',
    dataIndex: 'status',
  },
];

export const columnsMonth = [
  {
    title: 'Tình trạng KR tháng',
    width: 100,
    key: 'status',
    dataIndex: 'status',
  },
];
